<script>
import { mapGetters } from 'vuex'

import AdsPostpaidPaymentCard from './ads-postpaid-payment-card.vue'
import AdsPostpaidBankTransfer from './ads-postpaid-bank-transfer.vue'
import AdsButton from '@/views/ads/components/AdsButton.vue'

const TABS = {
  CARD: 'card',
  BANK_TRANSFER: 'bank-transfer',
}

export default {
  name: 'AdsPostpaidPaymentMethod',
  components: {
    AdsPostpaidPaymentCard,
    AdsPostpaidBankTransfer,
    AdsButton,
  },
  data() {
    return {
      tabActive: TABS.CARD,
      TABS,
      isPending: false,
    }
  },
  computed: {
    ...mapGetters('ads', ['paymentData', 'userType']),
  },
  created() {
    if (!this.paymentData) {
      this.backToPreviousRoute()
    }
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  methods: {
    backToPreviousRoute() {
      if (this.prevRoute?.path.includes('ads/postpaid/invoice')) {
        this.$router.go('-1')
      } else {
        this.$router.replace('/ads/postpaid/invoice/')
      }
    },
    onSelectTab(tab) {
      this.tabActive = tab
    },
  },
}
</script>

<template>
  <div class="ads-postpaid-payment-method">
    <template v-if="!isPending">
      <h1>
        {{ $t('ads_select_payment_method') }}
      </h1>
      <div class="flex mt-6 mb-5">
        <div
          class="flex-1 cursor-pointer pb-1 tab"
          :class="{
            tabActive: tabActive === TABS.CARD,
          }"
          @click="onSelectTab(TABS.CARD)"
        >
          <p class="text-center">{{ $t('ads_card') }}</p>
        </div>
        <div
          class="flex-1 cursor-pointer pb-1 tab"
          :class="{
            tabActive: tabActive === TABS.BANK_TRANSFER,
          }"
          @click="onSelectTab(TABS.BANK_TRANSFER)"
        >
          <p class="text-center">{{ $t('ads_bank_transfer') }}</p>
        </div>
      </div>
      <AdsPostpaidPaymentCard v-show="tabActive === TABS.CARD" />
      <AdsPostpaidBankTransfer
        v-show="tabActive === TABS.BANK_TRANSFER"
        :is-pending.sync="isPending"
        :payment-data="paymentData"
      />
    </template>

    <template v-else>
      <div class="flex flex-col items-center gap-5">
        <span class="ads-warning-icon">
          <svg-icon icon-class="ads-warning" />
        </span>
        <h1 class="txt-pending-title">
          {{ $t('ads_postpaid_pending_confirmation') }}
        </h1>
        <p class="txt-pending-desc">
          {{ $t('ads_postpaid_pending_confirmation_desc') }}
        </p>
        <AdsButton variant="primary" class="w-full" @click="$router.go('-1')">
          {{ $t('ads_postpaid_understand') }}
        </AdsButton>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.ads-postpaid-payment-method {
  width: 100%;
  text-align: start;

  h1 {
    font-size: 18px;
    font-weight: 600;
  }

  .tab {
    color: var(--content-mid);
    border-bottom: 2px solid var(--border-mid);
  }

  .tabActive {
    border-bottom: 2px solid #8267db;

    p {
      font-weight: bold;
      color: #8267db;
    }
  }

  .ads-warning-icon {
    svg {
      width: 72px !important;
      height: 72px !important;
      margin: 0 auto;
    }
  }

  .txt-pending-title {
    font-size: 24px;
    text-align: center;
  }

  .txt-pending-desc {
    color: var(--content-mid);
    text-align: center;
  }
}
</style>
